import React from "react";
import {Modal} from "react-bootstrap";
import {Field, Form, Formik} from "formik";
import {Input, Select} from "../../../../_metronic/_partials/controls";


export function OrderEditForm({
                                  handleSave,
                                  formValues,
                                  onHide,
                                  statuses
                              }) {
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={formValues}
                onSubmit={(values) => {
                    handleSave(values);
                }}
            >
                {({handleSubmit}) => (

                    <Form className="form form-label-right">
                        <Modal.Body className="overlay overlay-block cursor-default">
                            <div className="form-group row">
                                <div className="col-lg-4">
                                    <Select name="status_id" label="وضعیت سفارش">
                                        {statuses.map(status =>
                                            <option value={status.id} key={status.id}>{status.name}</option>
                                        )}
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <a className="btn btn-primary d-block"
                                       target="_blank"
                                       href={`https://www.trendyol.com${formValues.product.trendyolUrl}`}>
                                        نمایش محصول
                                    </a>
                                </div>

                            </div>
                            <div className="form-group row">
                                <div className="col-lg-4">
                                    <Field
                                        name="id"
                                        component={Input}
                                        placeholder="شماره سفارش"
                                        label="شماره سفارش"
                                    />

                                </div>
                                <div className="col-lg-4">
                                    <Field
                                        name="bascket_id"
                                        component={Input}
                                        placeholder="شماره سبد"
                                        label="شماره سبد"
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <Field
                                        name="price"
                                        component={Input}
                                        placeholder="قیمت"
                                        label="قیمت"
                                    />
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                کنسل
                            </button>
                            <> </>
                            <button
                                type="submit"
                                className="btn btn-primary btn-elevate"
                                onSubmit={handleSubmit}
                            >
                                <i className="fa fa-save"/>
                                ذخیره
                            </button>

                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </>
    );
}
